module.exports = __webpack_public_path__ + "img/closed-left.b033c069.svg";